import { createSlice } from "@reduxjs/toolkit";
import { getNodeTemperatures, getNodesDropdown, getNodeReplacementHistoryOptions, } from "../thunk/nodes-thunk";
const initialState = {
    nodeTemperatures: null,
    temperaturesLoading: false,
    temperaturesError: null,
    nodesDropdown: null,
    dropdownLoading: false,
    dropdownError: null,
    replacementHistoryOptions: [],
    replacementHistoryLoading: false,
    replacementHistoryError: null,
};
const nodeLogSlice = createSlice({
    name: "nodeLog",
    initialState,
    reducers: {
        clearNodeTemperatures: (state) => {
            state.nodeTemperatures = null;
            state.temperaturesError = null;
        },
        clearNodesDropdown: (state) => {
            state.nodesDropdown = null;
            state.dropdownError = null;
        },
        clearNodeLogState: (state) => {
            state.nodeTemperatures = null;
            state.temperaturesError = null;
            state.nodesDropdown = null;
            state.dropdownError = null;
            state.replacementHistoryOptions = [];
            state.replacementHistoryLoading = false;
            state.replacementHistoryError = null;
        },
    },
    extraReducers: (builder) => {
        // Get node temperatures
        builder
            .addCase(getNodeTemperatures.pending, (state) => {
            state.temperaturesLoading = true;
            state.temperaturesError = null;
        })
            .addCase(getNodeTemperatures.fulfilled, (state, action) => {
            state.temperaturesLoading = false;
            state.nodeTemperatures = action.payload;
        })
            .addCase(getNodeTemperatures.rejected, (state, action) => {
            state.temperaturesLoading = false;
            state.temperaturesError = action.payload;
        });
        // Get nodes dropdown
        builder
            .addCase(getNodesDropdown.pending, (state) => {
            state.dropdownLoading = true;
            state.dropdownError = null;
        })
            .addCase(getNodesDropdown.fulfilled, (state, action) => {
            state.dropdownLoading = false;
            state.nodesDropdown = action.payload;
        })
            .addCase(getNodesDropdown.rejected, (state, action) => {
            state.dropdownLoading = false;
            state.dropdownError = action.payload;
        });
        builder
            .addCase(getNodeReplacementHistoryOptions.pending, (state) => {
            state.replacementHistoryLoading = true;
            state.replacementHistoryError = null;
        })
            .addCase(getNodeReplacementHistoryOptions.fulfilled, (state, action) => {
            var _a, _b;
            state.replacementHistoryLoading = false;
            state.replacementHistoryOptions = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.options) !== null && _b !== void 0 ? _b : [];
        })
            .addCase(getNodeReplacementHistoryOptions.rejected, (state, action) => {
            state.replacementHistoryLoading = false;
            state.replacementHistoryError = action.payload;
            state.replacementHistoryOptions = [];
        });
    },
});
export const { clearNodeTemperatures, clearNodesDropdown, clearNodeLogState } = nodeLogSlice.actions;
export default nodeLogSlice.reducer;
